// English catalog — base translations.
// Same keys as fr.js. Missing keys fall back to FR (see useT logic).

const en = {
    // ─── Common ──────────────────────────────────────────────────────────
    'common.app_name': 'CAP Assurances',
    'common.tagline': 'Insurance Brokerage',
    'common.loading': 'Loading...',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.view': 'View',
    'common.detail': 'Detail',
    'common.search': 'Search',
    'common.export': 'Export',
    'common.print': 'Print',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    'common.required': 'Required',
    'common.optional': 'Optional',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.all': 'All',
    'common.none': 'None',
    'common.total': 'Total',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.amount': 'Amount',
    'common.created_at': 'Created at',
    'common.updated_at': 'Last updated',

    // ─── Authentication ──────────────────────────────────────────────────
    'auth.login.title': 'Sign in',
    'auth.login.subtitle': 'Secure broker portal',
    'auth.login.phone': 'Phone',
    'auth.login.password': 'Password',
    'auth.login.submit': 'Sign in',
    'auth.login.loading': 'Signing in...',
    'auth.login.broker_tagline': 'Your trusted insurance broker',
    'auth.logout.success': 'Signed out successfully',
    'auth.session.expired': 'Your session has expired. Please sign in again.',
    'auth.session.idle_warning': 'You will be signed out in {seconds} seconds due to inactivity.',
    'auth.session.stay_connected': 'Stay signed in',

    // ─── Navigation ──────────────────────────────────────────────────────
    'nav.dashboard': 'Dashboard',
    'nav.gestion': 'Management',
    'nav.clients': 'Clients',
    'nav.clients_list': 'Client list',
    'nav.clients_add': 'New client',
    'nav.contrats': 'Policies',
    'nav.contrats_list': 'Policy list',
    'nav.contrats_add': 'New policy',
    'nav.contrats_echeances': 'Expiring this month',
    'nav.echeances': 'Renewals',
    'nav.reglements': 'Payments',
    'nav.impayes': 'Unpaid',
    'nav.sinistres': 'Claims',
    'nav.rapports': 'Reports',
    'nav.bilans': 'Reports & States',
    'nav.audit': 'Audit log',
    'nav.admin': 'Administration',
    'nav.users': 'Users',
    'nav.roles': 'Roles',
    'nav.profile': 'My profile',
    'nav.config': 'Configuration',
    'nav.compagnies': 'Insurers',
    'nav.types_assurance': 'Insurance types',
    'nav.agences': 'Branches',
    'nav.parametrages': 'Settings',

    // ─── Megamenus: labels & short descriptions ──────────────────────────
    'nav.megamenu.section.gestion': 'OPERATIONS',
    'nav.megamenu.section.bilans': 'REPORTS & STATEMENTS',
    'nav.megamenu.section.referentiels': 'REFERENCE DATA',
    'nav.megamenu.section.administration': 'ADMINISTRATION',
    'nav.megamenu.section.actions': 'QUICK ACTIONS',

    'nav.megamenu.desc.clients': 'Individuals & companies',
    'nav.megamenu.desc.contrats': 'Policies & renewals',
    'nav.megamenu.desc.echeances': 'Contracts to renew',
    'nav.megamenu.desc.reglements': 'Payments & due dates',
    'nav.megamenu.desc.impayes': 'Follow-up & SMS reminders',
    'nav.megamenu.desc.sinistres': 'Claim filing & workflow',
    'nav.megamenu.desc.etat_reglements': 'Summary by contract / client',
    'nav.megamenu.desc.bilans': 'Overview',
    'nav.megamenu.desc.bordereau': 'Payments to insurers',
    'nav.megamenu.desc.etat_clients': 'Commitment / payment',
    'nav.megamenu.desc.compagnies': 'Partner insurers',
    'nav.megamenu.desc.types_assurance': 'Products offered',
    'nav.megamenu.desc.agences': 'Locations & contact info',
    'nav.megamenu.desc.marques_vehicule': 'Auto makers',
    'nav.megamenu.desc.referentiels_vehicule': 'Models & variants',
    'nav.megamenu.desc.parametrages': 'General settings',
    'nav.megamenu.desc.users': 'Staff & brokers',
    'nav.megamenu.desc.roles': 'RBAC permissions',
    'nav.megamenu.desc.audit': 'Activity log',

    'nav.megamenu.label.etat_reglements': 'Payment status',
    'nav.megamenu.label.bordereau': 'Broker statement',
    'nav.megamenu.label.etat_clients': 'Client statement',
    'nav.megamenu.label.marques_vehicule': 'Vehicle makes',
    'nav.megamenu.label.referentiels_vehicule': 'Vehicle reference',
    'nav.megamenu.label.new_admin': 'New administrator',

    // ─── Notifications ───────────────────────────────────────────────────
    'notif.center.title': 'Notifications',
    'notif.center.empty': 'No active alerts',
    'notif.center.empty_sub': "You're all caught up 🎉",
    'notif.center.up_to_date': 'All up to date',
    'notif.center.pending': 'Pending actions',
    'notif.center.mark_read': 'Mark as read',
    'notif.echeances': 'Policies expiring this month',
    'notif.impayes': 'Unpaid policies',
    'notif.sinistres': 'Claims to process',

    // ─── Clients (essential keys) ────────────────────────────────────────
    'clients.title': 'Client management',
    'clients.subtitle': 'Clients and prospects',
    'clients.add.title': 'New client',
    'clients.type.particulier': 'Individual',
    'clients.type.entreprise': 'Company',
    'clients.field.nom': 'Last name',
    'clients.field.prenom': 'First name(s)',
    'clients.field.raison_sociale': 'Company name',
    'clients.field.telephone': 'Phone',
    'clients.field.email': 'Email',
    'clients.field.adresse': 'Address',
    'clients.field.agence': 'Branch',
    'clients.empty': 'No client found',
    'clients.delete.confirm': 'Delete this client?',
    'clients.delete.success': 'Client deleted successfully',

    // ─── Contracts (essentials) ──────────────────────────────────────────
    'contrats.title': 'Policy management',
    'contrats.add.title': 'New policy',
    'contrats.renew.title': 'Policy renewal',
    'contrats.edit.title': 'Edit policy',
    'contrats.field.numero_police': 'Policy #',
    'contrats.field.compagnie': 'Insurer',
    'contrats.field.type_assurance': 'Insurance type',
    'contrats.field.prime_ttc': 'Premium (incl. tax)',
    'contrats.field.date_effet': 'Effective date',
    'contrats.field.date_echeance': 'Expiry date',
    'contrats.field.duree': 'Duration (months)',
    'contrats.empty': 'No policy found',
    'contrats.statut.actif': 'Active',
    'contrats.statut.expire': 'Expired',
    'contrats.statut.suspendu': 'Suspended',
    'contrats.statut.resilie': 'Terminated',
    'contrats.statut.renouvele': 'Renewed',

    // ─── Payments ────────────────────────────────────────────────────────
    'reglements.title': 'Payments',
    'reglements.encaisser': 'Collect',
    'reglements.encaisser.short': 'Collect ({amount} F)',
    'reglements.solde_complet': 'Full balance',
    'reglements.field.montant': 'Amount',
    'reglements.field.moyen': 'Payment method',
    'reglements.field.reference': 'Reference',
    'reglements.field.banque': 'Bank',
    'reglements.field.observation': 'Note',
    'reglements.moyen.especes': 'Cash',
    'reglements.moyen.cheque': 'Check',
    'reglements.moyen.virement': 'Wire transfer',
    'reglements.moyen.mobile_money': 'Mobile Money',

    // ─── Claims ──────────────────────────────────────────────────────────
    'sinistres.title': 'Claims',
    'sinistres.declare': 'Declare a claim',
    'sinistres.field.date_sinistre': 'Claim date',
    'sinistres.field.type': 'Type',
    'sinistres.field.description': 'Description',
    'sinistres.statut.declare': 'Declared',
    'sinistres.statut.en_cours': 'Under review',
    'sinistres.statut.regle': 'Settled',
    'sinistres.statut.rejete': 'Rejected',

    // ─── Preferences ─────────────────────────────────────────────────────
    'pref.theme.title': 'Appearance',
    'pref.theme.description': 'Choose the interface theme (saved for this browser).',
    'pref.theme.light': 'Light',
    'pref.theme.dark': 'Dark',
    'pref.theme.system': 'Auto (system)',
    'pref.lang.title': 'Language',
    'pref.lang.description': 'Choose the interface language.',
    'pref.lang.fr': 'Français',
    'pref.lang.en': 'English',

    // ─── Errors & validation ─────────────────────────────────────────────
    'error.required': 'The {field} field is required',
    'error.phone_format': 'The number must contain 10 digits (without country code)',
    'error.email_format': 'Invalid email format (e.g. name@domain.ci)',
    'error.api': 'Error while loading data',

    // ─── Dashboard ───────────────────────────────────────────────────────
    'dashboard.greeting.morning': 'Good morning',
    'dashboard.greeting.afternoon': 'Good afternoon',
    'dashboard.greeting.evening': 'Good evening',
    'dashboard.refresh': 'Refresh',
    'dashboard.period.week': 'This week',
    'dashboard.period.month': 'This month',
    'dashboard.period.quarter': 'This quarter',
    'dashboard.period.year': 'This year',
    'dashboard.agence.all': 'All branches',

    'dashboard.quick.title': 'Quick actions',
    'dashboard.quick.new_client': 'New client',
    'dashboard.quick.new_contrat': 'New policy',
    'dashboard.quick.cash_in': 'Collect payment',
    'dashboard.quick.declare_claim': 'Declare claim',

    'dashboard.kpi.production': 'My production',
    'dashboard.kpi.production.sub': '{count} active policies',
    'dashboard.kpi.ca': 'My revenue',
    'dashboard.kpi.ca.sub': 'This month',
    'dashboard.kpi.clients': 'My clients',
    'dashboard.kpi.clients.sub': '{count} active',
    'dashboard.kpi.vs_prev': 'vs {month}',
    'dashboard.kpi.no_compare': 'No previous reference',

    'dashboard.todo.title': "Today's to-do",
    'dashboard.todo.empty': '🎉 Nothing urgent — have a great day!',
    'dashboard.todo.empty_sub': "You're all caught up on priority actions.",
    'dashboard.todo.impayes': '{count} unpaid policies to follow up',
    'dashboard.todo.impayes.action': 'Follow up',
    'dashboard.todo.echeances_proches': '{count} policies to renew within 7 days',
    'dashboard.todo.echeances_proches.action': 'View',
    'dashboard.todo.sinistres': '{count} claims awaiting processing',
    'dashboard.todo.sinistres.action': 'Details',

    'dashboard.echeances.title': 'Upcoming renewals',
    'dashboard.echeances.tab_7': '7 days',
    'dashboard.echeances.tab_15': '15 days',
    'dashboard.echeances.tab_30': '30 days',
    'dashboard.echeances.empty': '✅ No upcoming renewal — perfect time to prospect',
    'dashboard.echeances.empty_window': 'No renewal in this window — {count} policy(ies) coming later',
    'dashboard.echeances.next_on': 'Next renewal on {date}',
    'dashboard.echeances.in_days': 'In {n}d',
    'dashboard.echeances.tomorrow': 'Tomorrow',
    'dashboard.echeances.today': 'Today',
    'dashboard.echeances.overdue': 'Overdue',

    'dashboard.chart.title': 'Revenue — last 6 months',
    'dashboard.chart.tooltip_contracts': '{n} policies',
    'dashboard.chart.empty': 'No data for this period',

    'dashboard.error.load': 'Could not load part of the dashboard. Click Refresh to retry.',

    // ─── Navbar & Layout ─────────────────────────────────────────────────
    'nav.open_menu': 'Open menu',
    'nav.close_menu': 'Close menu',
    'nav.create': 'Create',
    'nav.create_client': 'New client',
    'nav.create_contrat': 'New policy',
    'nav.create_reglement': 'Collect payment',
    'nav.create_sinistre': 'Declare claim',
    'nav.agence.all': 'All branches',
    'nav.agence.label': 'Active branch',
    'nav.help': 'Help & shortcuts',
    'nav.help_full': 'Help center',
    'nav.logout': 'Sign out',
    'nav.my_profile': 'My profile',
    'nav.user.role_label': 'Role',
    'nav.user.agence_label': 'Branch',
    'nav.theme.light_short': 'Light',
    'nav.theme.dark_short': 'Dark',
    'nav.theme.system_short': 'Auto',
    'nav.theme.title': 'Theme: {mode} (click to change)',
    'nav.locale.title': 'Language: {locale} (click to switch to {next})',

    // ─── Breadcrumb ──────────────────────────────────────────────────────
    'breadcrumb.home': 'Home',

    // ─── Footer ──────────────────────────────────────────────────────────
    'footer.copyright': '© {year} Cap Assurances — Insurance Brokerage',
    'footer.made_with': 'Made with',
    'footer.in_ci': 'in Côte d\'Ivoire',
    'footer.legal': 'Legal notice',
    'footer.privacy': 'Privacy',
    'footer.support': 'Support',
    'footer.version': 'Backoffice v{version}',

    // ─── Force password change ───────────────────────────────────────────
    'force_password.title': 'Password change required',
    'force_password.intro': 'For security reasons, you must change your default password before continuing.',
    'force_password.current': 'Current password',
    'force_password.new': 'New password',
    'force_password.confirm': 'Confirm new password',
    'force_password.submit': 'Change password',
    'force_password.submitting': 'Changing...',
    'force_password.min': 'At least 6 characters',
    'force_password.mismatch': 'Passwords do not match',
    'force_password.success': 'Password changed successfully',
    'force_password.error': 'Error while changing password',

    // ─── Accessibility ───────────────────────────────────────────────────
    'a11y.skip_to_content': 'Skip to main content',
    'a11y.session_warning_title': 'Session about to expire',
};

export default en;
